import classNames from 'classnames'
import React, { FC, useEffect } from 'react'

import WarningIcon from '../../../../assets/icons/warning2.svg'
import { useInternationalization } from '../../../../context/InternationalizationContext'
import { validateEmail } from '../../../../utils/stringUtils'
import styles from './LoginEmailForm.module.scss'

type Props = {
  email: string
  setEmail: (v: string) => void
  error: string
  setError: (v: string) => void
  emailNotValid: boolean
  setEmailNotValid: (v: boolean) => void
}

const EmailInput: FC<Props> = ({ email, setEmail, error, setError, emailNotValid, setEmailNotValid }) => {
  const { getText } = useInternationalization()

  const STRINGS = getText('LoginModal')

  useEffect(() => {
    if (error === STRINGS.emailError && !emailNotValid) setError('')
  }, [emailNotValid, error])
  useEffect(() => {
    const newEmailNotValid = !email || !validateEmail(email)
    setEmailNotValid(newEmailNotValid)
  }, [email])

  return (
    <>
      <div className={styles.emailFieldTitle}>{STRINGS.emailLabel}</div>

      <input
        name='email'
        type='email'
        placeholder='john.smith@gmail.com'
        value={email}
        onChange={(e) => setEmail(e.target.value || '')}
        onBlur={() => {
          if (!email || emailNotValid) setError(STRINGS.emailError)
        }}
        className={styles.emailFieldInput}
      />

      <div className={classNames(styles.fieldError, { [styles.fieldErrorHidden]: !error })}>
        <WarningIcon />

        <span>{error}</span>
      </div>
    </>
  )
}

export default EmailInput
